import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/** Heartbeat every 30s + mark offline on unload. */
export function useChitChatPresence() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    let alive = true;

    const ping = (online: boolean) => {
      supabase.rpc("set_user_online", { _online: online }).then(() => {});
    };
    ping(true);
    const id = window.setInterval(() => {
      if (alive) ping(true);
    }, 30_000);

    const onUnload = () => ping(false);
    window.addEventListener("beforeunload", onUnload);

    return () => {
      alive = false;
      window.clearInterval(id);
      window.removeEventListener("beforeunload", onUnload);
      ping(false);
    };
  }, [user?.id]);
}
